var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-fade-transition',[(_vm.splashScreen)?_c('div',{staticClass:"splash-screen"},[_c('img',{staticClass:"logo",attrs:{"src":require("./assets/logo.png"),"alt":"logo"}})]):_vm._e()]),_c('router-view'),_c('vue-snotify')],1)}
var staticRenderFns = []

export { render, staticRenderFns }